import { take, mergeMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { Resolve } from '@angular/router';
import { Injectable } from '@angular/core';
import { EmployeeService } from '../services/employee.service';

@Injectable({
  providedIn: 'root'
})
export class ResolveEmployeeService implements Resolve<any> {

  constructor(
    private employeeService: EmployeeService) { }

  resolve(): Observable<any> {
    return this.employeeService.page(10,1).pipe(
      take(1),
      mergeMap(teste => {
        return of(teste['object']);
      })
    );
  }

}
